module.exports = __webpack_public_path__ + "img/hz6.d79c10fa.png";